import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { Button } from "Components/Base/Inputs/Button";

const STYLE_CONTAINER = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 1,
  padding: "24px !important",
  marginTop: "24px !important",
};

const STYLE_ICON = { fontSize: "40px", color: "var(--colorTextSecondary)" };

const STYLE_ACTION = { marginTop: "8px !important" };

/**
 * EmptyState component displays an empty state message with optional icon, title, description, and action button
 * @param {Object} props - Component props
 * @param {React.ReactNode} [props.icon] - Optional icon element to display
 * @param {string} [props.title=""] - Title text to display
 * @param {string} [props.description=""] - Description text to display
 * @param {string} [props.actionLabel=""] - Label text for the action button
 * @param {Function} [props.onAction=null] - Callback function called when action button is clicked
 * @param {Object} [props.sx={}] - Additional sx styles to apply to the container
 * @returns {JSX.Element} EmptyState component
 */
const EmptyState = ({
  icon = null,
  title = "",
  description = "",
  actionLabel = "",
  onAction = null,
  sx = {},
}) => {
  return (
    <Box sx={{ ...STYLE_CONTAINER, ...sx }}>
      {icon ? (
        <Box sx={STYLE_ICON}>
          {icon}
        </Box>
      ) : null}
      {title ? (
        <Typography variant="h3" color="textPrimary">
          {title}
        </Typography>
      ) : null}
      {description ? (
        <Typography variant="body1" color="textSecondary">
          {description}
        </Typography>
      ) : null}
      {actionLabel && onAction ? (
        <Box sx={STYLE_ACTION}>
          <Button onClick={onAction}>{actionLabel}</Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default EmptyState;

